/**
 * KV Product bundle block — variant picker, Swiper color row, size chart, ATC.
 * Loaded as a theme asset so layout/theme.liquid output filters cannot corrupt inline scripts.
 */
(function () {
  'use strict';

  var KV_CART_SYNC_ATTR = 'data-kv-cart-sync';

  function shopifyRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function parseConfig(root) {
    var el = root.querySelector('[data-kv-bundle-config]');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('[kv-bundle] Invalid config JSON', e);
      return null;
    }
  }

  function installKvCartCheckoutGuard() {
    if (window.__kvCartCheckoutGuard) return;
    window.__kvCartCheckoutGuard = true;

    function isCheckoutClick(target) {
      if (!target || !target.closest) return false;
      if (target.closest('#CartDrawer-Checkout')) return true;
      if (target.closest('button[name="checkout"]')) return true;
      if (target.closest('input[name="checkout"]')) return true;
      var a = target.closest('a[href]');
      if (a) {
        var href = a.getAttribute('href') || '';
        if (/\/checkout(\?|#|$)/.test(href) || href === '/checkout') return true;
      }
      return false;
    }

    document.addEventListener(
      'click',
      function (e) {
        if (!document.documentElement.hasAttribute(KV_CART_SYNC_ATTR)) return;
        if (!isCheckoutClick(e.target)) return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        if (!document.documentElement.hasAttribute(KV_CART_SYNC_ATTR)) return;
        var f = e.target;
        if (!f || f.id !== 'CartDrawer-Form') return;
        var sub = e.submitter;
        if (sub && sub.getAttribute('name') === 'checkout') {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  function kvCartSyncBegin() {
    document.documentElement.setAttribute(KV_CART_SYNC_ATTR, 'true');
  }

  function kvCartSyncEnd() {
    document.documentElement.removeAttribute(KV_CART_SYNC_ATTR);
  }

  function kvSleep(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function initBundle(root) {
    if (!root || root.getAttribute('data-kv-bundle-ready') === 'true') return;

    var config = parseConfig(root);
    var form = root.querySelector('form.kv-product-form');
    if (!config || !form) return;

    var variants = config.variants || [];
    var variantProductTypes = config.variantProductTypes || {};
    var labels = config.labels || {};
    var productId = config.productId;
    var firstVariantId = config.firstVariantId;
    var initialVariantIdFromServer = config.initialVariantId;
    var engravingProductVariantId = config.engravingVariantId;
    var rootUrl = shopifyRoot();

    var variantInput = form.querySelector('[data-kv-variant-id]');
    var optionGroups = form.querySelectorAll('[data-option-index]');
    var addToCartBtn = form.querySelector('.kv-add-to-cart-btn');
    var stockStatus = form.querySelector('[data-kv-stock-status]');
    var stockMessage = form.querySelector('[data-kv-stock-message]');
    var stickyBar = root.querySelector('.kv-sticky-addtocart');
    var stickyBtn = stickyBar ? stickyBar.querySelector('.sticky-addtocart-btn') : null;
    var stickyAtcMq = window.matchMedia('(max-width: 767.98px)');
    var stickyAtcIo = null;
    var sizeChartOpenBtn = form.querySelector('[data-open-size-chart]');
    var sizeChartDrawer = root.querySelector('[data-size-chart-drawer]');
    var activeProductTypeFilter = '';
    var kvColorSwipers = [];

    installKvCartCheckoutGuard();

    function getFilteredVariants() {
      if (!activeProductTypeFilter) return variants;
      return variants.filter(function (v) {
        var pt = variantProductTypes[String(v.id)];
        if (pt == null || pt === '') return true;
        return pt === activeProductTypeFilter;
      });
    }

    function getVariantIdFromUrl() {
      try {
        var params = new URLSearchParams(window.location.search);
        var raw = params.get('variant');
        if (raw == null || raw === '') return null;
        var id = parseInt(raw, 10);
        return isNaN(id) ? null : id;
      } catch (e) {
        return null;
      }
    }

    function findVariantById(id) {
      if (id == null || id === '') return undefined;
      var n = Number(id);
      if (isNaN(n)) return undefined;
      return variants.find(function (v) {
        return Number(v.id) === n;
      });
    }

    function norm(s) {
      return s == null ? '' : String(s).trim();
    }

    function setActiveOptionsForVariant(variant) {
      if (!variant || !variant.options) return;
      variant.options.forEach(function (value, index) {
        var group = form.querySelector('[data-option-index="' + index + '"]');
        if (!group) return;
        group.querySelectorAll('.kv-option-btn').forEach(function (item) {
          item.classList.remove('is-active');
        });
        var match = null;
        var want = norm(value);
        group.querySelectorAll('.kv-option-btn').forEach(function (btn) {
          if (norm(btn.getAttribute('data-option-value')) === want) match = btn;
        });
        if (match) match.classList.add('is-active');
      });
    }

    function getSelectedOptions() {
      var selected = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.kv-option-btn.is-active');
        selected.push(active ? active.getAttribute('data-option-value') : '');
      });
      return selected;
    }

    function findVariant() {
      var selected = getSelectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return norm(opt) === norm(selected[i]);
        });
      });
    }

    function updateOptionAvailability() {
      var filteredVars = getFilteredVariants();
      optionGroups.forEach(function (group, groupIndex) {
        var isColorGroup = group.getAttribute('data-is-color-option') === 'true';
        var buttons = group.querySelectorAll('.kv-option-btn');
        buttons.forEach(function (button) {
          var value = button.getAttribute('data-option-value');
          var selected = getSelectedOptions();

          var existsInFilter = filteredVars.some(function (v) {
            return v.options[groupIndex] === value;
          });
          button.classList.toggle('kv-filtered-hidden', activeProductTypeFilter && !existsInFilter);

          var hasAvailableMatch;
          if (isColorGroup) {
            hasAvailableMatch = filteredVars.some(function (v) {
              return v.available && v.options[groupIndex] === value;
            });
          } else {
            hasAvailableMatch = filteredVars.some(function (v) {
              if (!v.available) return false;
              if (v.options[groupIndex] !== value) return false;
              return v.options.every(function (opt, idx) {
                if (idx === groupIndex) return true;
                return !selected[idx] || opt === selected[idx];
              });
            });
          }

          button.classList.toggle('is-disabled', !hasAvailableMatch);
        });

        var active = group.querySelector('.kv-option-btn.is-active');
        if (active && active.classList.contains('kv-filtered-hidden')) {
          active.classList.remove('is-active');
          var firstVisible = group.querySelector('.kv-option-btn:not(.kv-filtered-hidden)');
          if (firstVisible) firstVisible.classList.add('is-active');
        }
      });
    }

    function formatSelectedValue(index, value) {
      var group = form.querySelector('[data-option-index="' + index + '"]');
      if (!group) return value;
      var optionName = (group.getAttribute('data-option-name') || '').toLowerCase();
      if (
        optionName.indexOf('size') > -1 ||
        optionName.indexOf('maat') > -1 ||
        optionName.indexOf('koko') > -1
      ) {
        var firstPart = value.split('|')[0] || value;
        return firstPart.replace('EU', '').trim();
      }
      return value;
    }

    function dispatchVariantChange(variantId) {
      document.dispatchEvent(
        new CustomEvent('kv:variant:change', {
          detail: { productId: productId, variantId: variantId },
        })
      );
    }

    function updateStockStatus(variant) {
      if (!stockStatus || !stockMessage || !variant) return;
      var isAvailable = !!variant.available;
      stockStatus.classList.toggle('kv-stock-status--in-stock', isAvailable);
      stockStatus.classList.toggle('kv-stock-status--out', !isAvailable);
      stockMessage.textContent = isAvailable
        ? labels.in_stock_text || ''
        : labels.out_of_stock_text || '';
    }

    function updateVariant() {
      var variant = findVariant();
      if (!variant && variantInput && variantInput.value) {
        var hid = parseInt(variantInput.value, 10);
        if (!isNaN(hid)) variant = findVariantById(hid);
      }
      if (!variant || !addToCartBtn) return;
      variantInput.value = variant.id;
      variant.options.forEach(function (value, index) {
        var selectedText = form.querySelector('[data-selected-option-index="' + index + '"]');
        if (selectedText) selectedText.textContent = formatSelectedValue(index, value);
      });

      if (variant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = labels.button_text || 'Add to cart';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = labels.sold_button_text || 'Sold out';
      }

      updateStockStatus(variant);
    }

    function fetchCartJson() {
      return fetch(rootUrl + 'cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      }).then(function (response) {
        if (!response.ok) throw new Error('cart.js');
        return response.json();
      });
    }

    function kvPostCartAddJson(payload) {
      return fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      }).then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) {
            var err = new Error((body && (body.description || body.message)) || 'add_failed');
            err.kvBody = body;
            throw err;
          }
          return body;
        });
      });
    }

    function cartLineGroupId(item) {
      if (!item || !item.properties) return '';
      var p = item.properties;
      var v = p['_vr_engraving_id'];
      if (v == null) v = p._vr_engraving_id;
      return v == null ? '' : String(v);
    }

    function cartHasEngravingPair(cart, mainVariantId, engravingVariantId, groupId) {
      var items = cart.items || [];
      var gid = String(groupId);
      var hasMain = items.some(function (it) {
        return Number(it.variant_id) === Number(mainVariantId) && cartLineGroupId(it) === gid;
      });
      var hasEngraving = items.some(function (it) {
        return Number(it.variant_id) === Number(engravingVariantId) && cartLineGroupId(it) === gid;
      });
      return hasMain && hasEngraving;
    }

    function cartRemoveAllLinesForEngravingGroup(groupId) {
      return fetchCartJson().then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (item, index) {
          if (cartLineGroupId(item) === String(groupId)) {
            updates[String(index + 1)] = 0;
          }
        });
        if (!Object.keys(updates).length) return cart;
        return fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json',
          },
          body: JSON.stringify({ updates: updates }),
        }).then(function (r) {
          if (!r.ok) throw new Error('cart_update');
          return r.json();
        });
      });
    }

    function refreshCartSections(attempt) {
      attempt = attempt || 0;
      return fetch(rootUrl + '?sections=cart-drawer,cart-icon-bubble')
        .then(function (response) {
          if (!response.ok) throw new Error('sections');
          return response.json();
        })
        .then(function (sections) {
          Object.keys(sections).forEach(function (sectionId) {
            var sectionWrapper = document.getElementById('shopify-section-' + sectionId);
            if (sectionWrapper) sectionWrapper.innerHTML = sections[sectionId];
          });
        })
        .catch(function () {
          if (attempt < 2) {
            return kvSleep(350 * (attempt + 1)).then(function () {
              return refreshCartSections(attempt + 1);
            });
          }
        });
    }

    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        if (typeof drawer.open === 'function') drawer.open();
        drawer.setAttribute('open', 'open');
        drawer.classList.add('active');
      }
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    function openSizeChart() {
      if (!sizeChartDrawer) return;
      sizeChartDrawer.classList.add('is-open');
      sizeChartDrawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('kv-size-drawer-open');
    }

    function closeSizeChart() {
      if (!sizeChartDrawer) return;
      sizeChartDrawer.classList.remove('is-open');
      sizeChartDrawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('kv-size-drawer-open');
    }

    function initColorSwipers() {
      kvColorSwipers.forEach(function (sw) {
        try {
          sw.destroy(true, true);
        } catch (e) {}
      });
      kvColorSwipers = [];

      if (!window.Swiper) return false;

      form.querySelectorAll('.kv-color-swiper').forEach(function (el) {
        if (el.classList.contains('swiper-initialized')) return;
        kvColorSwipers.push(
          new Swiper(el, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            freeMode: true,
            navigation: {
              nextEl: el.querySelector('.kv-color-swiper-next'),
              prevEl: el.querySelector('.kv-color-swiper-prev'),
            },
          })
        );
      });
      return kvColorSwipers.length > 0 || !form.querySelector('.kv-color-swiper');
    }

    function waitForSwiperAndInit() {
      if (initColorSwipers()) return;
      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (initColorSwipers() || attempts >= 60) clearInterval(timer);
      }, 100);
    }

    form.querySelectorAll('.kv-option-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-option-index]');
        if (!group) return;
        var isColorOptionGroup = group.getAttribute('data-is-color-option') === 'true';
        group.querySelectorAll('.kv-option-btn').forEach(function (item) {
          item.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        if (isColorOptionGroup) {
          var galleryVariantId =
            btn.getAttribute('data-gallery-variant-id') || String(firstVariantId);
          dispatchVariantChange(galleryVariantId);
        }
        updateVariant();
        updateOptionAvailability();
        updateVariant();
      });
    });

    if (engravingProductVariantId) {
      var toggle = form.querySelector('[data-kv-engraving-toggle]');
      var wrap = form.querySelector('[data-kv-engraving-input-wrap]');
      var inp = form.querySelector('[data-kv-engraving-input]');
      var closeBtn = form.querySelector('[data-kv-engraving-close]');
      var countEl = form.querySelector('[data-kv-engraving-count]');
      if (toggle && wrap && inp && closeBtn && countEl) {
        var suffix = labels.engraving_char_suffix || '/20';
        toggle.addEventListener('click', function () {
          toggle.style.display = 'none';
          wrap.style.display = 'block';
          inp.value = '';
          countEl.textContent = '0' + suffix;
          setTimeout(function () {
            inp.focus();
          }, 0);
        });
        closeBtn.addEventListener('click', function () {
          inp.value = '';
          countEl.textContent = '0' + suffix;
          wrap.style.display = 'none';
          toggle.style.display = 'flex';
        });
        inp.addEventListener('input', function () {
          countEl.textContent = String(inp.value.length) + suffix;
        });
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (form.getAttribute('data-kv-atc-in-flight') === '1') return;
      if (!variantInput.value) return;
      closeSizeChart();

      form.setAttribute('data-kv-atc-in-flight', '1');
      kvCartSyncBegin();

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = labels.adding_text || 'Lisätään…';

      var variantId = parseInt(variantInput.value, 10);
      var variant = findVariantById(variantId);
      var engrInput = form.querySelector('[data-kv-engraving-input]');
      var engravingText =
        engrInput && engrInput.value ? String(engrInput.value).trim() : '';

      function finishAtc() {
        form.removeAttribute('data-kv-atc-in-flight');
        kvCartSyncEnd();
        updateVariant();
      }

      function runCartAddFormData() {
        return fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: new FormData(form),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            return refreshCartSections(0);
          })
          .then(function () {
            try {
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            } catch (e1) {}
            openCartDrawer();
          })
          .catch(function () {
            window.location.href = rootUrl + 'cart';
          })
          .finally(finishAtc);
      }

      function runEngravingBundleAdd() {
        var engravingIdentifier = '_vr_engraving_id';
        var groupId = Date.now() + '-' + Math.floor(Math.random() * 10000);
        var cartLabel = labels.engraving_cart_label || 'Engraving';
        var opt1 = variant.option1 != null ? String(variant.option1) : '';
        var opt2 = variant.option2 != null ? String(variant.option2) : '';
        var mainProps = {};
        mainProps[cartLabel] = engravingText;
        mainProps[engravingIdentifier] = groupId;
        var engravingProps = {
          _Engraved_Item_For: opt1 + ' - ' + opt2,
          _vr_engraving_id: groupId,
        };

        function addEngravingLineAttempt(attempt) {
          attempt = attempt || 0;
          return kvPostCartAddJson({
            items: [{ id: engravingProductVariantId, quantity: 1, properties: engravingProps }],
          })
            .then(function () {
              return fetchCartJson();
            })
            .then(function (cart) {
              if (cartHasEngravingPair(cart, variantId, engravingProductVariantId, groupId)) {
                return cart;
              }
              if (attempt < 3) {
                return kvSleep(400 + attempt * 350).then(function () {
                  return addEngravingLineAttempt(attempt + 1);
                });
              }
              throw new Error('engraving_verify');
            });
        }

        kvPostCartAddJson({ items: [{ id: variantId, quantity: 1, properties: mainProps }] })
          .then(function () {
            return fetchCartJson();
          })
          .then(function (cart) {
            var gid = String(groupId);
            var mainOk = (cart.items || []).some(function (it) {
              return Number(it.variant_id) === Number(variantId) && cartLineGroupId(it) === gid;
            });
            if (!mainOk) throw new Error('main_missing');
            return addEngravingLineAttempt(0);
          })
          .then(function () {
            return refreshCartSections(0);
          })
          .then(function () {
            return fetchCartJson();
          })
          .then(function (cart) {
            if (cartHasEngravingPair(cart, variantId, engravingProductVariantId, groupId)) return;
            return kvSleep(300)
              .then(function () {
                return fetchCartJson();
              })
              .then(function (cart2) {
                if (
                  !cartHasEngravingPair(cart2, variantId, engravingProductVariantId, groupId)
                ) {
                  throw new Error('post_refresh_mismatch');
                }
              });
          })
          .then(function () {
            try {
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            } catch (e2) {}
            openCartDrawer();
          })
          .catch(function () {
            return cartRemoveAllLinesForEngravingGroup(groupId)
              .catch(function () {})
              .then(function () {
                return refreshCartSections(0);
              })
              .catch(function () {})
              .then(function () {
                window.location.href = rootUrl + 'cart';
              });
          })
          .finally(finishAtc);
      }

      if (engravingProductVariantId && engravingText && variant) {
        runEngravingBundleAdd();
      } else {
        runCartAddFormData();
      }
    });

    if (sizeChartOpenBtn) {
      sizeChartOpenBtn.addEventListener('click', openSizeChart);
    }
    if (sizeChartDrawer) {
      sizeChartDrawer.querySelectorAll('[data-close-size-chart]').forEach(function (closeEl) {
        closeEl.addEventListener('click', closeSizeChart);
      });
      if (!root.getAttribute('data-kv-escape-bound')) {
        root.setAttribute('data-kv-escape-bound', 'true');
        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && sizeChartDrawer.classList.contains('is-open')) {
            closeSizeChart();
          }
        });
      }
    }

    var urlVariantId = getVariantIdFromUrl();
    var initialVariant =
      findVariantById(urlVariantId) ||
      findVariantById(initialVariantIdFromServer) ||
      variants[0];
    if (initialVariant) {
      setActiveOptionsForVariant(initialVariant);
      if (variantInput) variantInput.value = initialVariant.id;
    }
    var galleryId = initialVariant ? initialVariant.id : firstVariantId;
    dispatchVariantChange(galleryId);
    updateVariant();
    updateOptionAvailability();
    updateVariant();

    waitForSwiperAndInit();

    function syncStickyAtcAria() {
      if (!stickyBar) return;
      stickyBar.setAttribute(
        'aria-hidden',
        stickyBar.classList.contains('is-visible') ? 'false' : 'true'
      );
    }

    if (stickyBar && stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      function applyIntersection() {
        if (!stickyAtcMq.matches) {
          stickyBar.classList.remove('is-visible');
          syncStickyAtcAria();
          if (stickyAtcIo) {
            stickyAtcIo.disconnect();
            stickyAtcIo = null;
          }
          return;
        }
        if (stickyAtcIo) stickyAtcIo.disconnect();
        stickyAtcIo = new IntersectionObserver(
          function (entries) {
            var ent = entries[0];
            var rect = ent && ent.boundingClientRect;
            var pastBundle = ent && !ent.isIntersecting && rect && rect.top < 0;
            stickyBar.classList.toggle('is-visible', !!pastBundle);
            syncStickyAtcAria();
          },
          { root: null, threshold: 0, rootMargin: '0px' }
        );
        stickyAtcIo.observe(root);
      }

      applyIntersection();
      if (stickyAtcMq.addEventListener) {
        stickyAtcMq.addEventListener('change', applyIntersection);
      } else if (stickyAtcMq.addListener) {
        stickyAtcMq.addListener(applyIntersection);
      }
    }

    if (!root.getAttribute('data-kv-tab-bound')) {
      root.setAttribute('data-kv-tab-bound', 'true');
      document.addEventListener('kv:tab:filter', function (e) {
        if (!root.isConnected) return;
        activeProductTypeFilter = e.detail && e.detail.filter ? e.detail.filter : '';
        updateOptionAvailability();

        optionGroups.forEach(function (group) {
          var cur = group.querySelector('.kv-option-btn.is-active');
          if (!cur || cur.classList.contains('kv-filtered-hidden')) {
            if (cur) cur.classList.remove('is-active');
            var first = group.querySelector(
              '.kv-option-btn:not(.kv-filtered-hidden):not(.is-disabled)'
            );
            if (first) first.classList.add('is-active');
          }
        });

        updateVariant();
        kvColorSwipers.forEach(function (sw) {
          sw.update();
        });

        var colorGroup = form.querySelector('[data-is-color-option="true"]');
        if (colorGroup) {
          var activeColor = colorGroup.querySelector('.kv-option-btn.is-active');
          if (activeColor) {
            var galleryVarId =
              activeColor.getAttribute('data-gallery-variant-id') || String(firstVariantId);
            dispatchVariantChange(galleryVarId);
          }
        }
      });
    }

    root.setAttribute('data-kv-bundle-ready', 'true');
  }

  function initTabVariant(scope) {
    var outer = (scope || document).querySelector('[data-kv-tab-variant]');
    if (!outer || outer.getAttribute('data-kv-tab-ready') === 'true') return;

    var filterTabs = outer.querySelectorAll('[data-kv-tab-filter]');
    filterTabs.forEach(function (tab) {
      var link = tab.querySelector('a');
      if (!link) return;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var isActive = tab.classList.contains('active');
        filterTabs.forEach(function (t) {
          t.classList.remove('active');
        });
        if (isActive) {
          document.dispatchEvent(new CustomEvent('kv:tab:filter', { detail: { filter: '' } }));
        } else {
          tab.classList.add('active');
          document.dispatchEvent(
            new CustomEvent('kv:tab:filter', {
              detail: { filter: tab.getAttribute('data-kv-tab-filter') },
            })
          );
        }
      });
    });

    outer.setAttribute('data-kv-tab-ready', 'true');
  }

  function initVariantGallery(gallery) {
    if (!gallery || gallery.getAttribute('data-kv-gallery-ready') === 'true') return;
    var productId = gallery.getAttribute('data-kv-gallery-product-id');
    if (!productId) return;

    function showVariantGallery(variantId) {
      gallery.querySelectorAll('[data-variant-gallery]').forEach(function (group) {
        var isActive = group.getAttribute('data-variant-gallery') === String(variantId);
        group.classList.toggle('is-active', isActive);
        if (isActive) {
          var scroller = group.querySelector('.kv-variant-gallery-group-in');
          if (scroller) scroller.scrollTo({ left: 0, behavior: 'auto' });
        }
      });
    }

    function bindArrowScroll(group) {
      var scroller = group.querySelector('.kv-variant-gallery-group-in');
      var prev = group.querySelector('.kv-gallery-prev');
      var next = group.querySelector('.kv-gallery-next');
      if (!scroller || !prev || !next) return;

      function getSlideStep() {
        var firstSlide = scroller.querySelector('.kv-variant-gallery-item');
        if (!firstSlide) return scroller.clientWidth;
        var styles = window.getComputedStyle(scroller);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return Math.round(firstSlide.getBoundingClientRect().width + gap);
      }

      prev.addEventListener('click', function () {
        scroller.scrollBy({ left: -getSlideStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        scroller.scrollBy({ left: getSlideStep(), behavior: 'smooth' });
      });
    }

    function bindThumbnails(group) {
      var scroller = group.querySelector('.kv-variant-gallery-group-in');
      var slides = group.querySelectorAll('.kv-variant-gallery-item');
      var thumbs = group.querySelectorAll('.kv-gallery-thumb');
      if (!scroller || !slides.length || !thumbs.length) return;

      function setActiveThumb(index) {
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var index = Number(thumb.getAttribute('data-thumb-index'));
          var target = slides[index];
          if (!target) return;
          target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          setActiveThumb(index);
        });
      });

      scroller.addEventListener(
        'scroll',
        function () {
          var baseLeft = scroller.getBoundingClientRect().left;
          var activeIndex = 0;
          var closest = Number.POSITIVE_INFINITY;
          slides.forEach(function (slide, index) {
            var distance = Math.abs(slide.getBoundingClientRect().left - baseLeft);
            if (distance < closest) {
              closest = distance;
              activeIndex = index;
            }
          });
          setActiveThumb(activeIndex);
        },
        { passive: true }
      );
    }

    gallery.querySelectorAll('.kv-variant-gallery-group').forEach(bindArrowScroll);
    gallery.querySelectorAll('.kv-variant-gallery-group').forEach(bindThumbnails);

    document.addEventListener('kv:variant:change', function (event) {
      if (!event.detail || String(event.detail.productId) !== String(productId)) return;
      showVariantGallery(event.detail.variantId);
    });

    gallery.setAttribute('data-kv-gallery-ready', 'true');
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('.kv-custom-bundle[data-kv-bundle]').forEach(initBundle);
    context.querySelectorAll('[data-kv-gallery-product-id]').forEach(initVariantGallery);
    initTabVariant(scope || document);
  }

  window.KvBundle = {
    init: initBundle,
    initAll: initAll,
    initTabVariant: initTabVariant,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });
})(); 
